export const DASHBOARD_SELLERS_SUMMARY = 'DASHBOARD_SELLERS_SUMMARY';
export const DASHBOARD_SELLERS_SALES = 'DASHBOARD_SELLERS_SALES';
export const DASHBOARD_TOP_RANKING = 'DASHBOARD_TOP_RANKING';
export const DASHBOARD_DATA_SALESMAN = 'DASHBOARD_DATA_SALESMAN';
export const DASHBOARD_DATA_SUPPLIER = 'DASHBOARD_DATA_SUPPLIER';
export const SUPPLIER_FILTER = 'SUPPLIER_FILTER';
export const FILTER_SELECTION = 'FILTER_SELECTION';
export const DASHBOARD_COUNTER_SUMMARY = 'DASHBOARD_COUNTER_SUMMARY';
